/**
 * The column fields that every members table is built from.
 *
 * Columns that only make sense for a single table, such as {@link SEATS_COLUMN}, are not part of
 * this list and are added by that table instead.
 */
export const MEMBERS_TABLE_COLUMNS = ["name", "user", "email", "status", "role", "joinedDate", "options"];

/**
 * Column showing the Sphere XG and SCENE seats a member holds, and letting Enterprise Admins assign
 * the ones they do not hold yet.
 *
 * It is only meaningful on the workspace members page: the SCENE members table lists nothing but
 * seat holders, and the other member tables are not scoped to a workspace subscription.
 */
export const SEATS_COLUMN = "seats";

/**
 * Members table columns without the "name" column.
 * Useful for tables where member identity is shown via the "user" column instead.
 */
export const WORKSPACE_MEMBERS_TABLE_COLUMNS = MEMBERS_TABLE_COLUMNS.filter(col => col !== "name" && col !== "joinedDate");

/**
 * Returns the columns of the workspace members page, adding the seats column right after "role"
 * when the plan of the workspace includes seats
 *
 * @param shouldShowSeats Whether the plan of the workspace includes any seat, see doesPlanIncludeSeats
 */
export function getWorkspaceMembersTableColumns(shouldShowSeats) {
  return WORKSPACE_MEMBERS_TABLE_COLUMNS.flatMap(column => column === "role" && shouldShowSeats ? [column, SEATS_COLUMN] : [column]);
}

/** The labels for the columns in the members table */
export const MEMBERS_TABLE_COLUMN_LABELS = {
  name: "Name",
  user: "User",
  email: "Email",
  status: "Status",
  role: "Role",
  joinedDate: "Added date",
  seats: "Seats",
  options: "Options"
};

/** Sortable column fields for the members table */
export const MEMBERS_SORTABLE_FIELDS = ["user", "name", "email", "status", "role", "joinedDate", "seats"];

/** The labels for the sortable members columns */

/** The labels for the sortable members columns */
export const MEMBERS_SORT_COLUMN_LABELS = {
  user: "User",
  name: "Name",
  email: "Email",
  status: "Status",
  role: "Role",
  joinedDate: "Added date",
  seats: "Seats"
};

/**
 * Team members table columns without the "name" column.
 * Useful for tables where member identity is shown via the "user" column instead.
 */
export const TEAM_MEMBERS_TABLE_COLUMNS = MEMBERS_TABLE_COLUMNS.filter(col => col !== "name");